import type { InboundNode } from '../../types';
import { ConditionCard } from '../condition-card';
import { Bold, Times, Within, SubFilters } from '../condition-parts';

type InboundConditionProps = { node: InboundNode };

export function InboundCondition({ node }: InboundConditionProps) {
  const operator = node.inverse ? 'not received' : 'received';
  return (
    <ConditionCard node={node}>
      <Bold>Inbound SMS</Bold> {operator}
      <Times times={node.times} />
      <Within within={node.within} />
      <SubFilters filters={node.filters} filtersOperator={node.filtersOperator} />
    </ConditionCard>
  );
}
